import React, { useState, useEffect } from 'react';
import footerStyles from '../assets/css/gapsy-footer.module.css';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import axios from "axios";
import { helpDeskEmailApi, helpDeskToEmailId, emailAttachment, hierarchy_user } from "../components/ApiProperty";
import avatarImage from '../assets/images/avatar.png';
import { FaPaperclip, FaTrash } from 'react-icons/fa';
import styles from '../assets/css/gapsy-dashboard.module.css';

const Footer = () => {
    const [isDocumentModalVisible, setDocumentModalVisible] = useState(false);
    const documents = [
        { fileName: 'User_Guide.pdf' },
    ];
    const filteredDocuments = documents; // Show all documents
    //help desk start
    const [showModal, setShowModal] = useState(false);
    const [fromEmail, setFromEmail] = useState("");
    const [toEmail, setToEmail] = useState('');
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [file, setFile] = useState(null); // State for file attachment
    const [errors, setErrors] = useState({ subject: "", message: "" });
    const [uploadStatus, setUploadStatus] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [loading, setLoading] = useState(false);
    const [jsonResponse, setJsonResponse] = useState(null);
    const [showHierarchyModal, setShowHierarchyModal] = useState(false);
    const userRole = localStorage.getItem('userRole');
    const handleHierarchyModalClose = () => setShowHierarchyModal(false);
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const currentUserId = localStorage.getItem("userid");

    //Function for handling help Desk
    useEffect(() => {
        // Retrieve the email from localStorage and set it to state
        const emailFromStorage = localStorage.getItem('Email_Id');
        if (emailFromStorage) {
            setFromEmail(emailFromStorage);
        }
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    const handleShow = () => setShowModal(true);
    const handleClose = () => { setShowModal(false); setShowHierarchyModal(false); }

    const validateForm = () => {
        let isValid = true;
        const newErrors = { subject: "", message: "" };

        if (!subject.trim()) {
            newErrors.subject = "Subject is required.";
            isValid = false;
        }

        if (!message.trim()) {
            newErrors.message = "Message is required.";
            isValid = false;
        }

        setErrors(newErrors); // Update the errors state
        return isValid;
    };

    const handleSendEmail = async () => {
        setLoading(true);
        if (!validateForm()) return; // Stop execution if validation fails

        // Extracting each input element to a variable
        const fileInput = file;
        const subjectInput = subject;
        const messageInput = message;
        const fromEmailInput = fromEmail;
        const toEmailInput = helpDeskToEmailId;

        // Create FormData instance
        const formData = new FormData();
        let config = ""; // Declare config here

        if (fileInput) {
            // Add file to FormData if available
            formData.append('file', fileInput);

            // Make the file upload request
            const uploadResponse = await axios.post(emailAttachment, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "x-csrf-token": csrfToken
                },
                withCredentials: true,
            });

            if (uploadResponse.status == 200) {
                // Prepare config with attachment path
                config = {
                    subject: subjectInput,
                    message: messageInput,
                    fromMail: fromEmailInput,
                    toMail: toEmailInput,
                    attachmentPath: fileInput.name, // Assuming fileInput.name is correct
                };
            } else {
                setLoading(false);
                setModalMessage("Attachment Failure try again later or contact your admin");
                setMessageType('failure');
                setTimeout(() => {
                    setModalMessage(''); // Clear the message or close the modal
                    setMessageType('');
                }, 5000); // 5000 ms = 5 seconds
            }

        } else {
            // Prepare config without file
            config = {
                subject: subjectInput,
                message: messageInput,
                fromMail: fromEmailInput,
                toMail: toEmailInput,
                headers: {
                    "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken
                },
                withCredentials: true,
            };
        }

        // Send the email
        const response = await axios.post(helpDeskEmailApi, config); // Pass config directly as payload

        if (response.data) {
            setLoading(false);
            setModalMessage(response.data.message);
            setMessageType('success');
            setTimeout(() => {
                setModalMessage(''); // Clear the message or close the modal
                setMessageType('');
            }, 5000); // 5000 ms = 5 seconds
            // Reset inputs
            setFile(null);
            setSubject("");
            setMessage("");
        } else {
            setLoading(false);
            alert('Could not send email! Check with your admin');
            setModalMessage("Something went wrong sending email!!!");
            setMessageType('failure');
            setTimeout(() => {
                setModalMessage(''); // Clear the message or close the modal
                setMessageType('');
            }, 5000); // 5000 ms = 5 seconds
            // Reset inputs
            setFile(null);
            setSubject("");
            setMessage("");
        }
        setLoading(false);
    };

    const handleHierarchyModalShow = async () => {
        try {
            const config = {
                headers: {
                    userId: localStorage.getItem("userid"), "x-csrf-token": csrfToken
                },
                params: { "userRole": userRole },
                withCredentials: true,
            };
            const response = await axios.post(hierarchy_user, {}, config);
            setJsonResponse(response.data); // Save the API response to the state
            setShowHierarchyModal(true); // Show the modal
        } catch (error) {
            console.error("Error fetching hierarchy data:", error);
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = setFile(e.target.files[0]); // Set the selected file
        if (selectedFile && !['image/jpeg', 'image/jpg', 'image/png'].includes(selectedFile.type)) {
            setUploadStatus('Only  JPG, and PNG files are allowed.');
            setFile(null);
            return;
        }
    };

    // This function will simulate a click on the hidden file input
    const handleAttachClick = () => {
        document.getElementById('fileInput').click();
    };

    // Function to handle downloading a document
    const handleDownload = async (fileName) => {
        try {
            // const response = await fetch(`${PortURL}/documents/${fileName}`);
            const response = await fetch(`/documents/${fileName}`);
            if (!response.ok) {
                throw new Error(`Could not download ${fileName}. Status: ${response.status}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName.replace(/_/g, ' ');
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };
    // const highlightClass = user.userId === jsonResponse.userId ? 'border-primary shadow-sm' : 'border-secondary';

    const filteredMakers = jsonResponse?.Maker?.filter(m => m.userId !== currentUserId) || [];

    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: `repeat(${filteredMakers.length}, 1fr)`,
        gap: '1rem',
    };


    const gridStyle1 = {
        display: 'grid',
        gridTemplateColumns: `repeat(${filteredMakers.length}, 1fr)`,
        gap: '10rem',
    };

    const groupedMakers = {};

    jsonResponse?.Maker?.forEach((maker) => {
        const checkerId = maker.MappedId;
        if (!groupedMakers[checkerId]) {
            groupedMakers[checkerId] = [];
        }
        groupedMakers[checkerId].push(maker);
    });

    const makersGroupedByChecker = (jsonResponse?.Maker || []).reduce((acc, maker) => {
        if (!acc[maker.MappedId]) acc[maker.MappedId] = [];
        acc[maker.MappedId].push(maker);
        return acc;
    }, {});

    return (
        <footer
            className={`footer text-white py-1 ${styles.pageFullBackground}`}
            style={{
                borderTop: "1px solid #3d405b"
            }}
        >
            <div className="container d-flex justify-content-center gap-4 mt-3">
                <a href="#" onClick={handleHierarchyModalShow} className="text-decoration-none text-dark d-flex align-items-center mx-3 gap-2">
                    <i className="bi bi-diagram-3"></i> User Hierarchy
                </a>
                <a href="#" onClick={handleShow} className="text-decoration-none text-dark d-flex align-items-center mx-3 gap-2">
                    <i className="bi bi-life-preserver"></i> Help Desk
                </a>
                <a href="#" onClick={() => setDocumentModalVisible(true)} className="text-decoration-none text-dark d-flex align-items-center mx-3 gap-2">
                    <i className="bi bi-journal-text"></i> Documentation
                </a>
            </div>

            {isDocumentModalVisible && (
                <Modal show={isDocumentModalVisible} onHide={() => setDocumentModalVisible(false)} centered>
                    <Modal.Header className={`text-white p-2 ${footerStyles.modalHeader} ${footerStyles.modalHeaderColor} ${footerStyles.whiteCloseButton}`}>
                        <Modal.Title className={footerStyles.modalTitle}>Available Document</Modal.Title>
                        {/* Custom Close Button */}
                        <button
                            type="button"
                            className={`btn-close btn-close-white ${footerStyles.whiteCloseButton}`}
                            aria-label="Close"
                            onClick={() => setDocumentModalVisible(false)}
                        ></button>

                    </Modal.Header>
                    <Modal.Body>
                        <ul className={footerStyles.listGroup}>
                            {filteredDocuments.length > 0 ? (
                                <li
                                    key={filteredDocuments[0].fileName}
                                    className={footerStyles.listGroupItem}
                                    onClick={() => handleDownload(filteredDocuments[0].fileName)}
                                >
                                    <a href="#" className={footerStyles.link}>
                                        <small>{filteredDocuments[0].fileName.replace(/_/g, ' ')}</small>
                                    </a>
                                </li>
                            ) : (
                                <li className={footerStyles.noDocument}>No document available</li>
                            )}
                        </ul>
                    </Modal.Body>
                </Modal>
            )}

            {/* Help Desk Email */}
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header className={`text-white p-2 ${footerStyles.modalHeader} ${footerStyles.modalHeaderColor} ${footerStyles.whiteCloseButton}`}>
                    <Modal.Title className={footerStyles.modalTitle}>Email Assistance</Modal.Title>
                    {/* Custom Close Button */}
                    <button
                        type="button"
                        className={`btn-close btn-close-white ${footerStyles.whiteCloseButton}`}
                        aria-label="Close"
                        onClick={handleClose}
                    ></button>
                </Modal.Header>

                <Modal.Body>
                    <Form encType="multipart/form-data" style={{ opacity: loading ? 0.5 : 1 }}>
                        {/* To Email */}
                        <Form.Group controlId="formBasicToEmail" className="mb-3">
                            <Row>
                                <Col md={3} className="d-flex align-items-center">
                                    <Form.Label className="mb-0 text-muted">To Email</Form.Label>
                                </Col>
                                <Col md={9}>
                                    <Form.Control
                                        type="email"
                                        value="admin@gapsphere.com"
                                        readOnly
                                        className="form-control-sm border-0 bg-transparent"
                                    />
                                </Col>
                            </Row>
                        </Form.Group>

                        {/* Subject */}
                        <Form.Group controlId="formBasicSubject" className="mb-3">
                            <Row>
                                <Col md={3} className="d-flex align-items-center">
                                    <Form.Label className="mb-0 text-muted">Subject*</Form.Label>
                                </Col>
                                <Col md={9}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter subject..."
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                        className="form-control-sm"
                                    />
                                    {errors.subject && (
                                        <div className="text-danger small">{errors.subject}</div>
                                    )}
                                </Col>
                            </Row>
                        </Form.Group>

                        {/* Message */}
                        <Form.Group controlId="formBasicMessage" className="mb-3">
                            <Row>
                                <Col md={3} className="d-flex align-items-center">
                                    <Form.Label className="mb-0 text-muted">Message*</Form.Label>
                                </Col>
                                <Col md={9}>
                                    <Form.Control
                                        as="textarea"
                                        rows={5}
                                        maxLength={300}
                                        placeholder="Enter message... (max 300 characters)"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        className="form-control-sm"
                                        style={{ resize: 'none', fontSize: '12px' }}
                                    />
                                    <div className="small text-muted mt-1">{message.length}/300 characters</div>
                                    {errors.message && (
                                        <div className="text-danger small">{errors.message}</div>
                                    )}
                                </Col>
                            </Row>
                        </Form.Group>

                        {/* Attach File */}
                        <Form.Group controlId="formBasicFile" className="mb-2">
                            <Row>
                                <Col md={3} className="d-flex align-items-center">
                                    <Form.Label className="mb-0 text-muted">Attach File</Form.Label>
                                </Col>
                                <Col sm={9}>
                                    <div className="d-flex align-items-center">
                                        <FaPaperclip
                                            className="me-2"
                                            style={{ cursor: 'pointer', fontSize: 'qwpx' }}
                                            onClick={handleAttachClick}
                                        />
                                        {file && (
                                            <>
                                                <span className="me-2 small">{file.name}</span>
                                                <FaTrash
                                                    style={{ cursor: 'pointer', fontSize: '12px' }}
                                                    onClick={() => setFile(null)}
                                                />
                                            </>
                                        )}
                                    </div>
                                    <Form.Control
                                        type="file"
                                        id="fileInput"
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>

                    {/* Loading Spinner */}
                    {loading && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style={{ zIndex: 10 }}>
                            <div className="spinner-border text-dark" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {
                            setToEmail('');
                            setSubject('');
                            setMessage('');
                            setFile(null);
                        }}
                    >
                        Clear
                    </Button>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleSendEmail}
                    >
                        Send Email
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Hierarchy Modal */}
            <Modal show={showHierarchyModal} onHide={handleHierarchyModalClose} centered>

                <Modal.Header className={`text-white p-2 ${footerStyles.modalHeader} ${footerStyles.modalHeaderColor} ${footerStyles.whiteCloseButton}`}>
                    <Modal.Title className={footerStyles.modalTitle}>Hierarchy</Modal.Title>

                    <button
                        type="button"
                        className={`btn-close btn-close-white ${footerStyles.whiteCloseButton}`}
                        aria-label="Close"
                        onClick={handleClose}
                    ></button>
                </Modal.Header>

                <Modal.Body>
                    {jsonResponse && jsonResponse.userRole === "Checker" ? (
                        <div className="d-flex flex-column align-items-center w-100 px-4">

                            <div className="d-flex align-items-center border border-secondary border-1 p-2"
                                style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    // backgroundColor: currentUserId === jsonResponse.Admin[0].userId ? "#dbeafe" : "transparent"  // light blue fill
                                    backgroundColor:
                                        Array.isArray(jsonResponse.Admin) && jsonResponse.Admin.length > 0 &&
                                            currentUserId === jsonResponse.Admin[0].userId
                                            ? "#dbeafe"
                                            : "transparent"
                                }}>

                                <div className="me-3 rounded-circle bg-transparent border d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", overflow: "hidden" }}>
                                    <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                </div>
                                {Array.isArray(jsonResponse.Admin) && jsonResponse.Admin.length > 0 && (
                                    <div>
                                        <span className="d-block"><h6>{jsonResponse.Admin[0].userName} - {jsonResponse.Admin[0].userId}</h6></span>
                                        <div className="text-muted" style={{ fontSize: "12px" }}>{jsonResponse.Admin[0].userRole}</div>
                                    </div>
                                )}
                            </div>

                            <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                                <div style={{ width: '2px', height: '25px', backgroundColor: '#6c757d' }}></div>
                            </div>


                            <div className="d-flex align-items-center border border-secondary border-1 p-2"
                                style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    backgroundColor: currentUserId === jsonResponse.userId ? "#4578bbff" : "#5EB4E3"  // light blue fill
                                }}>
                                <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", backgroundColor: "white", overflow: "hidden" }}>
                                    <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                </div>
                                <div>
                                    <span className="d-block" style={{ color: '#ffffff' }}><h6>{jsonResponse.userName} - {jsonResponse.userId}</h6></span>
                                    <div className="" style={{ fontSize: "12px", color: '#ffffff' }}>{jsonResponse.userRole}</div>
                                </div>
                            </div>

                            {jsonResponse.Maker.length === 1 ? (
                                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                                    <div style={{ width: '2px', height: '25px', backgroundColor: '#6c757d' }}></div>
                                </div>
                            ) : null}

                            {jsonResponse?.Maker?.length > 1 ? (
                                <>
                                    <div style={{ width: '2px', height: '20px', backgroundColor: '#6c757d', margin: '0 auto' }}></div>

                                    {/* Horizontal line only */}
                                    <div className="mx-auto d-flex justify-content-between align-items-center" style={{ width: '83%', marginBottom: '0' }}>
                                        <div style={{ width: '50%', height: '2px', backgroundColor: '#6c757d', marginLeft: '36px' }}></div>
                                        <div style={{ width: '50%', height: '2px', backgroundColor: '#6c757d', marginRight: '40px' }}></div>
                                    </div>

                                    {/* Replace arrows with vertical lines */}
                                    <div className="w-100 px-4 d-flex justify-content-between align-items-center" style={{ marginTop: '-2px' }}>
                                        <div style={{ width: '2px', height: '28px', backgroundColor: '#6c757d', marginLeft: '45px' }}></div>
                                        <div style={{ width: '2px', height: '27px', backgroundColor: '#6c757d', marginRight: '52px' }}></div>
                                    </div>

                                    {/* Maker cards side-by-side */}
                                    <div className="d-flex justify-content-between w-100 gap-2 flex-wrap">
                                        {jsonResponse.Maker.map((maker) => (
                                            <div
                                                key={maker.userId}
                                                className="d-flex align-items-center border border-secondary border-1 p-2"
                                                style={{
                                                    width: "48%",
                                                    borderRadius: "8px",
                                                    backgroundColor: currentUserId === maker.userId ? "#dbeafe" : "transparent"  // light blue fill
                                                }}>
                                                <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", backgroundColor: "white", overflow: "hidden" }}>
                                                    <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                                </div>
                                                <div>
                                                    <span className="d-block"><h6>{maker.userName} - {maker.userId}</h6></span>
                                                    <div className="text-muted" style={{ fontSize: "12px" }}>{maker.userRole}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ) : (
                                jsonResponse.Maker.map((maker) => (
                                    <React.Fragment key={maker.userId}>
                                        <div className="d-flex align-items-center border border-secondary border-1 p-2"
                                            style={{
                                                width: "100%",
                                                borderRadius: "8px",
                                                backgroundColor: currentUserId === maker.userId ? "#dbeafe" : "transparent"  // light blue fill
                                            }}>
                                            <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", backgroundColor: "white", overflow: "hidden" }}>
                                                <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                            </div>
                                            <div>
                                                <span className="d-block"><h6>{maker.userName} - {maker.userId}</h6></span>
                                                <div className="text-muted" style={{ fontSize: "12px" }}>{maker.userRole}</div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))
                            )}

                        </div>
                    ) : jsonResponse && jsonResponse.userRole === "Maker" ? (
                        <div className="d-flex flex-column align-items-center w-100 px-4">
                            {Array.isArray(jsonResponse?.Admin) && jsonResponse.Admin.length > 0 && (
                                <>
                                    <div className="d-flex align-items-center border border-secondary border-1 p-2"
                                        style={{
                                            width: "100%",
                                            borderRadius: "8px",
                                            backgroundColor: currentUserId === jsonResponse.Admin[0].userId ? "#dbeafe" : "transparent"
                                        }}>
                                        <div className="me-3 rounded-circle bg-transparent border d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", overflow: "hidden" }}>
                                            <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                        </div>
                                        <div>
                                            <span className="d-block"><h6>{jsonResponse.Admin[0].userName} - {jsonResponse.Admin[0].userId}</h6></span>
                                            <div className="text-muted" style={{ fontSize: "12px" }}>{jsonResponse.Admin[0].userRole}</div>
                                        </div>
                                    </div>

                                    {/* Vertical line below Admin */}
                                    <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                                        <div style={{ width: '2px', height: '25px', backgroundColor: '#6c757d' }}></div>
                                    </div>
                                </>
                            )}

                            {Array.isArray(jsonResponse?.Checker) && jsonResponse.Checker.length > 0 && (
                                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                                    <div style={{ width: '2px', height: '25px', backgroundColor: '#6c757d' }}></div>
                                </div>
                            )}

                            {Array.isArray(jsonResponse?.Checker) && jsonResponse.Checker.length > 0 && (
                                <div className="d-flex align-items-center border border-secondary border-1 p-2"
                                    style={{
                                        width: "100%",
                                        borderRadius: "8px",
                                        backgroundColor: currentUserId === jsonResponse.Checker[0].userId ? "#dbeafe" : "transparent"
                                    }}>

                                    <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", backgroundColor: "white", overflow: "hidden" }}>
                                        <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                    </div>
                                    <div>
                                        <span className="d-block"><h6>{jsonResponse.Checker[0].userName} - {jsonResponse.Checker[0].userId}</h6></span>
                                        <div className="text-muted" style={{ fontSize: "12px" }}>{jsonResponse.Checker[0].userRole}</div>
                                    </div>
                                </div>
                            )}

                            {jsonResponse?.userRole === "Maker" && (
                                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                                    <div style={{ width: '2px', height: '25px', backgroundColor: '#6c757d' }}></div>
                                </div>
                            )}

                            <div className="d-flex align-items-center border border border-1 p-2"
                                style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    backgroundColor:
                                        Array.isArray(jsonResponse.Admin) && jsonResponse.Admin.length > 0 && currentUserId === jsonResponse.Admin[0].userId
                                            ? "#4578bbff"
                                            : "#5EB4E3"
                                }}>

                                <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", backgroundColor: "white", overflow: "hidden" }}>
                                    <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                </div>
                                <div>
                                    <span className="d-block" style={{ color: '#ffffff' }}>
                                        <h6>{jsonResponse.userName} - {jsonResponse.userId}</h6>
                                    </span>
                                    <div style={{ fontSize: "12px", color: '#ffffff' }}>{jsonResponse.userRole}</div>
                                </div>
                            </div>

                        </div>

                    ) : jsonResponse && jsonResponse.userRole === "Admin" ? (

                        <div className="d-flex flex-column align-items-center w-100 px-4">
                            <div className="d-flex align-items-center border border-secondary border-1 p-2"
                                style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    backgroundColor: currentUserId === jsonResponse.userId ? "#4578bbff" : "#5EB4E3"  // light blue fill
                                }}>
                                <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", overflow: "hidden" }}>
                                    <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                </div>
                                <div>
                                    <span className="d-block" style={{ color: "#ffffff" }}><h6>{jsonResponse.userName} - {jsonResponse.userId}</h6></span>
                                    <div className="" style={{ fontSize: "12px", color: "#ffffff" }}>{jsonResponse.userRole}</div>
                                </div>
                            </div>

                            {/* {(jsonResponse?.Checker?.length || 0) === 1 ? ( */}
                            {Array.isArray(jsonResponse?.Checker) && jsonResponse.Checker.length === 1 && (
                                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                                    <div style={{ width: '2px', height: '25px', backgroundColor: '#6c757d' }}></div>
                                </div>
                            )}

                            {Array.isArray(jsonResponse?.Checker) && jsonResponse.Checker.length > 1 && (
                                <>
                                    <div style={{ width: '2px', height: '20px', backgroundColor: '#6c757d', margin: '0 auto' }}></div>

                                    {/* Horizontal line only */}
                                    <div className="mx-auto d-flex justify-content-between align-items-center" style={{ width: '83%', marginBottom: '0' }}>
                                        <div style={{ width: '50%', height: '2px', backgroundColor: '#6c757d', marginLeft: '36px' }}></div>
                                        <div style={{ width: '50%', height: '2px', backgroundColor: '#6c757d', marginRight: '40px' }}></div>
                                    </div>

                                    {/* Replace arrows with vertical lines */}
                                    <div className="w-100 px-4 d-flex justify-content-between align-items-center" style={{ marginTop: '-2px' }}>
                                        <div style={{ width: '2px', height: '28px', backgroundColor: '#6c757d', marginLeft: '46px' }}></div>
                                        <div style={{ width: '2px', height: '27px', backgroundColor: '#6c757d', marginRight: '52px' }}></div>
                                    </div>
                                </>
                            )}


                            {/* Checkers in one row */}
                            <div className="d-flex justify-content-between w-100 gap-3 px-2">
                                {(jsonResponse?.Checker || []).map((checker) => (
                                    <div key={checker.userId} className="d-flex flex-column align-items-center" style={{ flex: 1 }}>
                                        <div className="d-flex align-items-center border border-secondary border-1 p-2"
                                            style={{
                                                width: "100%",
                                                borderRadius: "8px",
                                                backgroundColor: currentUserId === checker.userId ? "#dbeafe" : "transparent"  // light blue fill
                                            }}>
                                            <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", overflow: "hidden" }}>
                                                <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                            </div>
                                            <div>
                                                <span className="d-block"><h6>{checker.userName} - {checker.userId}</h6></span>
                                                <div className="text-muted" style={{ fontSize: "12px" }}>{checker.userRole}</div>
                                            </div>
                                        </div>
                                        {(() => {
                                            const makers = makersGroupedByChecker[checker.userId] || [];
                                            const totalCheckers = jsonResponse?.Checker?.length || 0;

                                            if (totalCheckers === 1 && makers.length > 1) {
                                                return (
                                                    <>
                                                        <div style={{ width: '2px', height: '20px', backgroundColor: '#6c757d', margin: '0 auto' }}></div>

                                                        <div className="mx-auto d-flex justify-content-between align-items-center" style={{ width: '74%', marginBottom: '0' }}>
                                                            {makers.map((_, idx, arr) => (
                                                                <div
                                                                    key={idx}
                                                                    style={{
                                                                        width: `${100 / arr.length}%`,
                                                                        height: '2px',
                                                                        backgroundColor: '#6c757d',
                                                                    }}
                                                                ></div>
                                                            ))}
                                                        </div>

                                                        <div
                                                            className="w-100 d-flex justify-content-between px-4 align-items-center"

                                                        >
                                                            {makers.map((_, idx, arr) => {
                                                                const isFirst = idx === 0;
                                                                const isLast = idx === arr.length - 1;

                                                                return (
                                                                    <div key={idx} style={{
                                                                        width: '2px', height: '28px', backgroundColor: '#6c757d', marginLeft: isFirst ? '28px' : '0',
                                                                        marginRight: isLast ? '29px' : '0',
                                                                    }}></div>
                                                                    // <div style={{ width: '2px', height: '27px', backgroundColor: '#6c757d', marginRight: '52px' }}></div>
                                                                );
                                                            })}

                                                        </div>
                                                    </>
                                                );
                                            }

                                            if (makers.length > 0) {
                                                return (
                                                    <div className="d-flex justify-content-center">
                                                        <div style={{ width: '2px', height: '28px', backgroundColor: '#6c757d' }}></div>
                                                    </div>
                                                );
                                            }

                                            return null;
                                        })()}

                                        <div className="d-flex flex-wrap justify-content-center gap-2 w-100">
                                            {makersGroupedByChecker[checker.userId]?.map((maker) => (
                                                <div key={maker.userId} className={`d-flex align-items-center border border-secondary border-1 p-2 ${currentUserId == maker.userId ? styles.highlightGlow : ''}`} style={{ borderRadius: "8px" }}>
                                                    <div className="bg-secondary me-3 rounded-circle" style={{ width: "40px", height: "40px", backgroundColor: "white", overflow: "hidden" }}>
                                                        <img src={avatarImage} alt="Avatar" className="w-100 h-100 object-fit-cover" />
                                                    </div>
                                                    <div>
                                                        <span className="d-block"><h6>{maker.userName} - {maker.userId}</h6></span>
                                                        <div className="text-muted" style={{ fontSize: "12px" }}>{maker.userRole}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    ) : null}
                </Modal.Body>
            </Modal>
        </footer>
    );
};

export default Footer;
